import { Plate } from './../../models/plate';
import { Component, OnInit } from '@angular/core';
import { LabMDM } from '../../masterdata/models/lab';
import { MessagesService } from "../../messages/messages.service";
import { ErrorHandler } from "../../utils/error-handler";
import { AdminSearchService } from './admin-search.service';
import { BeadChip } from './../../models/bead-chip';
import { Sample } from './../../models/sample';
import { AnnouncedService } from '../../apg-announced/services/announced.service';

@Component({
  selector: 'app-admin-search',
  templateUrl: './admin-search.component.html',
  styleUrls: ['./admin-search.component.css']
})


export class AdminSearchComponent implements OnInit {

  showSamplePopup: boolean;
  showBeadchipPopup: boolean;
  showPlatePopup: boolean;
  selectedPlateStepsMap: Map<any, any>;


  selectedLab: LabMDM;
  selectedLabId: string;
  plateIDRegex:string;
  beadchipIDRegex:string;
  searchedBatch: Plate;
  errorHandler: ErrorHandler = new ErrorHandler();
  blocked = false;
  selectedPlate: Plate;
  selectedBeadChips:BeadChip[];
  selectedSamples:Sample[];
  plateId:any;
  beadchipID1:string;
  beadchipID2:string;
  sampleId:string;
  position:string;
  sampleBeadchip: string = ''
  sampleBeadchipPos: string = ''
  
  searchedBeadchipID: string = ''

  constructor(
    private _messagesService: MessagesService,
    private adminSearchService: AdminSearchService,
    private announcementService:AnnouncedService
  ){}

    isPlate:boolean=false;
    isBeadchip:boolean=false;
    isSample:boolean=false;

  ngOnInit() {
    this.plateIDRegex = JSON.parse(localStorage.getItem("lab")).lab.plateIDRegex;
    this.beadchipIDRegex = JSON.parse(localStorage.getItem("lab")).lab.beadchipIDRegex;
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.searchedBatch = new Plate();
    this.selectedPlateStepsMap = new Map();
    this.showPlatePopup=false;
    this.showBeadchipPopup=false;
    this.showSamplePopup=false;
  }


  search(searchID: string) {
    this.selectedPlate=new Plate();
    if (!searchID || searchID.trim() == "") {
      this._messagesService.addWarningMessage({
        severity: "warn",
        summary: "Search ID Empty",
        detail: "Please enter Search ID to search",
      });
      return;
    }
    if(this.regexMatcher(this.plateIDRegex,searchID) || this.regexMatcher(this.beadchipIDRegex,searchID)){
      this.isSample=false;
      this.searchingPlate(searchID);
    }else {
      this.isSample=true;
      this.position="";
      this.sampleId="";
      this.serchingSample(searchID);
      this.isPlate=false;
      this.isBeadchip=false;
    }
  }

  regexMatcher(regex: string, searchID: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(searchID);
  }
  
 
  searchingPlate(plateid: string) {
    this.adminSearchService.fetchPlateByIDandLab(this.selectedLabId, plateid, "SOURCE").subscribe(
      (result) => {
        this.selectedPlate = result;
        if(this.selectedPlate.type=="BEADCHIP"){
          this.isPlate=false
          this.isBeadchip=true
          this.searchedBeadchipID = plateid
        }else{
          this.isBeadchip=false
          this.isPlate=true
          this.plateId = this.selectedPlate.plateID;
          this.selectedBeadChips = this.selectedPlate.beadChips;
          if (this.selectedBeadChips != null) {
            this.beadchipID1 = this.selectedBeadChips[0].beadChipID;
            this.beadchipID2 = this.selectedBeadChips[1].beadChipID;
          }
        }
      }
    )
  }
 
  serchingSample(sampleID: string) {
    this.blocked = true
    this.announcementService.getSampleFromDelivery(this.selectedLabId, sampleID).subscribe({
      next: (result) => {
        let sample = result.data[0]
        let sample_id = sample['_id']
        this.adminSearchService.fetchPlateBySample(this.selectedLabId, sample_id).subscribe(
          result => {
            this.blocked = false;
            this.selectedPlate = result;
            this.selectedSamples = result.samples;
            if (this.selectedPlate.samples && this.selectedPlate.samples.length > 0) {
              this.sampleId = this.selectedPlate.samples[0].sampleID
              this.position = this.selectedPlate.samples[0].position
              this.sampleBeadchip = this.selectedPlate.samples[0].beadChipID
              this.sampleBeadchipPos = this.selectedPlate.samples[0].beadChipPosition
            } else {
              this._messagesService.addWarningMessage({
                severity: 'warn', summary: 'Sample ' + sampleID + ' found',
                detail: 'Unable to pull complete data, please try again.'
              })
            }
          }
        )
      }, error: (_error) => {
        this.blocked = false;
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Sample ' + sampleID + ' found',
          detail: 'Unable to pull complete data, please try again.'
        })
      }
    })
  }

  searchingBeadchip(beadChipID:string){
    this.adminSearchService.fetchPlateByBeadchip(this.selectedLabId, beadChipID).subscribe(
      result=>{
        this.selectedPlate=result;
        this.searchedBeadchipID = beadChipID;
      }
    )
  }

}
